import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = hash.replace("#", "");
    const el = document.getElementById(id);

    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ 
            behavior: "smooth", 
            block: "start",
            inline: "start" 
        });
      }, 0);
    }
  }, [hash]);

  return null;
}